import { Icon } from '@graftcode/design-system'

import { isArtifactFeedsSettingsEnabled } from '@common/helpers'

import { SettingsCategory } from './enums'
import type { SettingsNavCategory } from './settings.interface'

const ARTIFACT_FEEDS_SETTINGS_DISABLED = !isArtifactFeedsSettingsEnabled()

export const SETTINGS_NAV_ITEMS: SettingsNavCategory[] = [
  {
    id: SettingsCategory.ACCOUNT,
    label: 'Account',
    items: [
      { id: 'account-general', label: 'General', icon: Icon.SettingsRegular, url: 'settings' },
      {
        id: 'account-your-workspaces',
        label: 'Your workspaces',
        icon: Icon.OrganizationRegular,
        url: 'settings/your-workspaces',
      },
    ],
  },
  {
    id: SettingsCategory.WORKSPACE,
    label: 'Workspace',
    items: [
      { id: 'workspace-general', label: 'General', icon: Icon.SettingsRegular, url: 'settings/workspace' },
      {
        id: 'workspace-members',
        label: 'Members',
        icon: Icon.PeopleRegular,
        url: 'settings/workspace/members',
      },
      {
        id: 'workspace-notifications',
        label: 'Notifications settings',
        icon: Icon.AlertRegular,
        url: 'settings/workspace/notifications',
        disabled: true,
      },
    ],
  },
  {
    id: SettingsCategory.PROJECT,
    label: 'Project',
    items: [
      { id: 'project-general', label: 'General', icon: Icon.SettingsRegular, url: 'settings/project' },
      {
        id: 'project-members',
        label: 'Members',
        icon: Icon.PeopleRegular,
        url: 'settings/project/members',
      },
      {
        id: 'project-artifact-feeds',
        label: 'Artifact feeds',
        icon: Icon.FolderRegular,
        url: 'settings/project/artifact-feeds',
        disabled: ARTIFACT_FEEDS_SETTINGS_DISABLED,
      },
      {
        id: 'project-activity-log',
        label: 'Team activity',
        icon: Icon.HistoryRegular,
        url: 'settings/project/activity-log',
      },
      { id: 'project-plans', label: 'Plans', icon: Icon.PaymentRegular, url: 'settings/project/plans', disabled: true },
      { id: 'project-keys', label: 'Project keys', icon: Icon.KeyRegular, url: 'settings/project/keys' },
    ],
  },
]

/**
 * Settings routes shown as disabled in the portal hamburger menu only.
 * Desktop sidebar / settings page nav use {@link SETTINGS_NAV_ITEMS} without these flags.
 */
export const SETTINGS_MOBILE_DISABLED_NAV_ITEM_IDS = new Set<string>([
  'workspace-notifications',
  'project-activity-log',
  'project-plans',
])
